/**
 * Content pages served by the generic CMS page route (`pages/CmsPage.tsx`),
 * one route per slug in both locale trees: `/about` and `/<secondary>/about`.
 *
 * To add a page: create a Pages doc with that slug in the CMS and add the
 * slug here. A slug listed here with no CMS doc is a real 404; a CMS doc whose
 * slug is not listed here is not routed (and not in the sitemap).
 *
 * Why a list rather than a `:slug` catch-all: `/:slug` would collide with the
 * `/:lang` locale tree (`/about` would rank as the home page of locale
 * "about"), so page routes are static segments.
 */
export const CMS_PAGE_SLUGS = ['about', 'privacy-policy'] as const

/** The front page is the Pages doc with this slug. */
export const HOME_PAGE_SLUG = 'home'
